import axiosClient from './axiosClient'

const employeeTypeAPi = {
  getAll: () => axiosClient.get('employeeTypes'),
}

export default employeeTypeAPi